import type { ReactNode } from "react";
import type { Tone } from "../../lib/stream-status";
import { cx } from "./cx";

const TONE: Record<Tone, string> = { ok: "bg-ok", info: "bg-info", warn: "bg-warn", bad: "bg-bad", idle: "bg-idle" };

/** `live` marks a stream that is on air: a red dot with a ping, like the landing page's LIVE badge. */
export function Pill({ tone, children, pulse, live }: { tone: Tone; children: ReactNode; pulse?: boolean; live?: boolean }) {
  return (
    <span className={cx("inline-flex items-center gap-1.5 rounded-full border-2 border-ink px-2.5 py-0.5 font-mono text-xs font-bold uppercase tracking-wider", TONE[tone])}>
      {live ? (
        <span aria-hidden="true" className="relative flex size-2">
          <span className="absolute inset-0 rounded-full bg-accent motion-safe:animate-ping-dot" />
          <span className="relative size-2 rounded-full bg-accent" />
        </span>
      ) : pulse && <span aria-hidden="true" className="size-2 rounded-full bg-ink motion-safe:animate-pulse" />}
      {children}
    </span>
  );
}
